import axios from 'axios';
import {
  getCountryAndLanguagePathFromUrl,
  getURLParameterByName,
} from '../../abstracts/utilities.js';

export function trackData (data = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

export function hashSha256(string) {
  return crypto.subtle.digest("SHA-256", string);
}

export function normalizeEmailForUserHash(email) {
  let emailArr = email.split('@'),
      emailUserName = emailArr[0],
      emailDomain = emailArr[1];

  // remove '+'
  if(emailArr[0].indexOf('+') > -1) {
    emailUserName = emailArr[0].split('+');
    emailUserName = emailUserName[0];
  }

  // remove '.' and set to lowercase for gmail/googlemail
  if(/^(gmail|googlemail)\.com\s*/.test(emailDomain)) {
    emailUserName = emailUserName.toLowerCase();
    emailUserName = emailUserName.split('.').join("");
  }

  return emailUserName + '@' + emailDomain;
}

export function getStudioUidByName(studios, name) {
  if(studios instanceof Array) {
    return studios.filter((studio) => studio.name == name)[0]?.id || '';
  } else {
    return  Object.values(studios?.studios).filter((studio) => studio.name == name)[0]?.id || '';
  }
}

export function getStudioByName(studios, name) {
  if(studios instanceof Array) {
    return studios.filter((studio) => studio.name == name)[0] || {};
  } else {
    return Object.values(studios?.studios).filter((studio) => studio.name == name)[0] || {};
  }
}

export function getLocationFinderJson (getStudios = false) {
  let params = '';

  if(getStudios) {
    params = '?studio=all'
  } else if(window.location.pathname.indexOf('/lp/') > -1) {
    let urlPath = window.location.pathname.split('/'),
        breg = urlPath[urlPath.indexOf('_breg') + 1],
        city = urlPath.indexOf('_city') > -1 ? urlPath[urlPath.indexOf('_city') + 1] : null,
        studio = urlPath.indexOf('_studio') > -1 ? urlPath[urlPath.indexOf('_studio') + 1] : null;

    // breg always exist
    params = '?breg=' + breg;

    if(!!city) {
      params += '&city=' + city;
    }

    if(!!studio) {
      params += '&studio=' + studio;
    }

  } else if (!!getURLParameterByName('action')) {
    params = '?action=' + getURLParameterByName('action');
  } else {
    params = '?studio=all'
  }

  return axios.get(window.location.origin + '/' + getCountryAndLanguagePathFromUrl() + '/api/v2/studios/' + params, {responseType: "json", transformResponse: (body) => body})
  .then((res) => {
    return JSON.parse(res.data);
  }).catch((err) => {
    window.location.href = window.location.origin + '/' + getCountryAndLanguagePathFromUrl() + '/404';
  });
}

export function getStudioSearchJson () {
  return axios.get(window.location.origin + '/' + getCountryAndLanguagePathFromUrl() + '/api/v2/studiosearch/', {responseType: "json", transformResponse: (body) => body})
  .then((res) => {
    return JSON.parse(res.data);
  }).catch((err) => {
    window.location.href = window.location.origin + '/' + getCountryAndLanguagePathFromUrl() + '/404';
  });
}
